import { endpoints } from '../Constants';
import { authHeader, toQueryStringURL } from '../Helpers';
import handleResponse from './helpers';

/**
 * Internal, cross-customer annotation productivity.
 *
 * One row per annotator per customer spanning every customer, which is why the
 * page needs no per-customer fan-out. The payload is D-1: the `asOf` it returns
 * is the authoritative freshness stamp and must be displayed rather than
 * recomputed on the client.
 */
function fetchProductivity(req = {}) {
	const url = toQueryStringURL(
		endpoints.ANNOTATION_PRODUCTIVITY,
		req?.params ?? {}
	);
	const requestOptions = {
		method: 'GET',
		headers: {
			...authHeader(),
			Accept: 'application/json',
			'Content-Type': 'application/json',
		},
	};
	return fetch(url, requestOptions).then(handleResponse);
}

const annotationDashboardServices = {
	fetchProductivity,
};

export default annotationDashboardServices;
